export class BrokerageConfigResponse {
  BrokerageConfigID: number;
  BrokerageID: number;
  ConfigName: string;
  ConfigValue: string;
}
